import Vue from 'vue'
import ElementUI, { Dialog, MessageBox } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/admin-theme.css'
import App from './App.vue'
import router from './router'
import store from './store'
import request from './api/request'

Vue.use(ElementUI)

// 全局关闭弹窗遮罩，并挂到 body，避免嵌套在侧栏布局内导致遮罩挡住弹窗无法点击
Dialog.props.modal.default = false
Dialog.props.appendToBody.default = true
MessageBox.setDefaults({ modal: false })

Vue.prototype.$request = request
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
